import _ from 'lodash';
import React from 'react';
import { gql } from '@apollo/client';
import routes from '@achievable-me/tundra-wizard/routes';
import { Link } from 'react-router-dom';
import { reverse } from 'named-urls';
import { Mutation } from '@apollo/react-components';
import SpinnerError from '$components/library/SpinnerError';
import ContentEditForm from './ContentEditForm';

import styles from './styles.scss';

const STAFF_UPDATE_CONTENT = gql`
  mutation StaffUpdateContent($input: UpdateContentInput!) {
    updateContent(input: $input) {
      content {
        uuid
        slug
        name
        availability
        markdown
      }
    }
  }
`;

const ProductContentEdit = (props) => {
  const { content, deleteNode, match, product } = props;
  const { slug: productSlug } = product;
  const { params } = match;
  const { contentUuid } = params;

  const contentInstance = _.find(content, (instance) => instance.uuid === contentUuid);
  const hasChildContent = _.some(content, (c) => c.parentUuid === contentInstance.uuid);

  const handleDelete = () => {
    deleteNode({
      variables: {
        input: {
          uuid: contentInstance.uuid,
        },
      },
    });
  };

  const learnUrl = reverse(routes.study.learn, {
    productSlug,
    contentUuid,
  });

  return (
    <div key={contentUuid} className={styles.layout}>
      <div className={styles.header}>
        <div>Content Uuid: {contentInstance.uuid}</div>
        <Link to={learnUrl} target="_blank">
          View as student <i className="fad fa-external-link" />
        </Link>
      </div>
      <Mutation mutation={STAFF_UPDATE_CONTENT}>
        {(updateContent, { loading, error }) => {
          if (loading || error) {
            return <SpinnerError error={error} />;
          }

          if (hasChildContent) {
            return (
              <div>
                <br />
                Parent nodes do not display content; navigate to a leaf node to display
                the text.
              </div>
            );
          }

          return (
            <ContentEditForm
              handleDelete={handleDelete}
              content={content}
              contentInstance={contentInstance}
              updateContent={updateContent}
            />
          );
        }}
      </Mutation>
    </div>
  );
};

export default ProductContentEdit;
